export class PartsCatalogSettingsV10 {
    constructor() {
        this.brand = null;
        this.vehicleType = null;
        this.catalogScope = null;
        this.steering = null;
        this.quantitySelection = null;
        this.localContent = null;
        this.catalogVersionOrRegion = null;
    }
    getBrand() {
        return this.brand;
    }
    setBrand(brand) {
        this.brand = brand;
    }
    getVehicleType() {
        return this.vehicleType;
    }
    setVehicleType(vehicleType) {
        this.vehicleType = vehicleType;
    }
    getCatalogScope() {
        return this.catalogScope;
    }
    setCatalogScope(catalogScope) {
        this.catalogScope = catalogScope;
    }
    getSteering() {
        return this.steering;
    }
    setSteering(steering) {
        this.steering = steering;
    }
    getCatalogVersionOrRegion() {
        return this.catalogVersionOrRegion;
    }
    setCatalogVersionOrRegion(catalogVersionOrRegion) {
        this.catalogVersionOrRegion = catalogVersionOrRegion;
    }
    getLocalContent() {
        return this.localContent;
    }
    setLocalContent(localContent) {
        this.localContent = localContent;
    }
    getQuantitySelection() {
        return this.quantitySelection;
    }
    setQuantitySelection(quantitySelection) {
        this.quantitySelection = quantitySelection;
    }
}
PartsCatalogSettingsV10.constructFromPlainObject = (sourceSettings) => {
    const targetSettings = new PartsCatalogSettingsV10();
    return Object.assign(targetSettings, sourceSettings);
};
//# sourceMappingURL=partsCatalogSettingsV10.js.map